module.exports = __webpack_public_path__ + "img/icon_transfer_bank.67b398d6.png";